import gql from 'graphql-tag';
import { imageUploadAttributes } from './types/image-uploads';

export const uploadImagesMutation = gql`
  mutation UploadImagesMutation($data: ImageUploadInput!) {
    uploadImages(data: $data) {
      ${imageUploadAttributes}
    }
  }
`;

export const destroyImageUploadMutation = gql`
  mutation DestroyImageUploadMutation($id: ID!) {
    destroyImageUpload(id: $id) {
      id
      status
    }
  }
`;

export const myImageUploadsQuery = gql`
  query MyImageUploadsQuery {
    me {
      id
      createdImageUploads {
        ${imageUploadAttributes}
      }
    }
  }
`;
